import './AboutMe.css';
import photo from './IMG-1e9b9394dfe65b43674ede0daafef840-V.jpg';

function AboutMe() {
  return (
    <section
      id='about'
      className='about-container'
    >
      <article>
        <img
          className='photo'
          src={photo}
          alt='aboutme'
        />
        <p>
          <h1> About me</h1>
          I'm a <b>Web developer</b> exploring different technologies and
          frameworks that catch my interest! I am open to offers for the
          position of frontend developer. If you're looking for a developer to
          add to your team, I'd love to hear from you!
          <br />I like solving complex problems: developing websites and web
          applications with a user-friendly interface. I am fascinated by the
          development process and the opportunity to create convenient and
          useful products.
        </p>
      </article>
      <article>
        <p>
          I finished <b>"Frontend Developer" course at Itgirlschool</b>. I
          practice programming every day. I am currently studying at
          <b> RS School</b>. Сompleted the course on
          <ul>
            <b>Udemy.com:</b>
            <li> Fundamental JavaScript.</li>
            <li>React from scratch for beginners.</li>
            <li>Redux for managing the state of React applications.</li>
            <li>Typescript for modern development.</li>
          </ul>
          <ul className='certificates'>
            <li>
              <img
                src='./imgs/certificates/UC-0df62974-3f70-48f2-81bc-91efa3816ba6.jpg'
                alt='certificate'
              />
            </li>
            <li>
              <img
                src='./imgs/certificates/UC-d9108b2c-d7aa-4d2d-bfff-6f9d15a9a52b (1).jpg'
                alt='certificate'
              />
            </li>
            <li>
              <img
                src='./imgs/certificates/UC-e3f328d9-29f9-4e48-9b7d-66b63f9bb41d.jpg'
                alt='certificate'
              />
            </li>
            <li>
              <img
                src='./imgs/certificates/UC-eff384d9-e94e-405b-b51e-62ae306c2c6b.jpg'
                alt='certificate'
              />
            </li>
          </ul>
          <ul>
            <b>My goals:</b>
            <li>Learn to write clean code.</li>
            <li>Work in a friendly development team.</li>
            <li>Work on interesting projects.</li>
            <li>Contribute to the success of the company.</li>
          </ul>
          <ul>
            <b>A few facts about me:</b>
            <li>
              As part of a commercial project, I developed a website for a
              museum and art space in a development team.
            </li>
            <li>
              Participated in an Itgirlschool internship in a project to create
              an educational application for the school.
            </li>
            <li>Developed an application (SPA) for learning foreign words.</li>
            <li>Participated in a hackathon.</li>
            <li>
              Passed 6 stages out of 7 in the selection process for an
              internship at Clevertec.
            </li>
            <li>I'm studing at RS School.</li>
          </ul>
        </p>
      </article>
    </section>
  );
}

export default AboutMe;
